import { PERMISSIONS } from '../../core/utils/permissions';
import { queryKeys } from '../../core/api/queryKeys';

export const ONBOARDING_PERMISSIONS = {
  APPROVE: PERMISSIONS.ORG_APPROVE,
  READ: PERMISSIONS.ORGS_READ,
};

export const ONBOARDING_QUERY_KEYS = queryKeys.onboarding;
